import {
  Paper,
  Grid,
  Button,
  Alert,
  Tabs,
  Tab,
  Box,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material";
import React, { useContext } from "react";

import constant from "../Costanti/Constant.js";
import "dayjs/locale/it";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { loadStripe } from "@stripe/stripe-js";
import InfoUserSocieta from "../infoUserSocieta";
import { Context } from "../Context.js";
import { useNavigate, useLocation } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";

import "./Abbonamento.css";

const Utenze = {
  ADMIN: 1,
  USER: 2,
  SOCIETA: 3,
};

const AbbonamentoSocietaCorso = () => {
  const stripePromise = loadStripe(
    "pk_live_51LvMKTIUBaKEna1TVuf3hbmFwVkBBzOEfsm0M7Jp6vsm0i7UsuPG87XyGnD77ANmLPs38bhhKECYn43B0fF9geSL00efgDLihY"
  );

  const { token, idTipoUtente } = useContext(Context);

  const navigate = useNavigate();
  const location = useLocation();

  // --- TAB NAV: mappa route <-> tab (gemella di Gruppo)
  const TABS = [
    {
      value: "/abbonamentoSocietaGruppo",
      label: "Iscrizione società",
      icon: <PersonIcon />,
    },
    {
      value: "/abbonamentoSocietaCorso",
      label: "Acquisto abbonamento corsi",
      icon: <GroupsIcon />,
    },
  ];

  const currentTab =
    TABS.find((t) => location.pathname.startsWith(t.value))?.value ||
    "/abbonamentoSocietaCorso";

  // --- Stato (logiche invariate)
  const [durataAbbonamento, setDurataAbbonamento] = React.useState("");
  const [valueData, setValueData] = React.useState(dayjs());

  const [DatePickerAnno, setDatePickerAnno] = React.useState(false);
  const [DatePickerMese, setDatePickerMese] = React.useState(false);
  const [DatePickerGiorno, setDatePickerGiorno] = React.useState(false);

  const [visualizzaPagina, setVisualizzaPagina] = React.useState(false);
  const [isClickableButton, setIsClickableButton] = React.useState(true);

  const [utenti10, setUtenti10] = React.useState(0);
  const [utenti15, setUtenti15] = React.useState(0);

  const [alertError, setAlertError] = React.useState(false);
  const [alertOk, setAlertOk] = React.useState(false);
  const [msgAlert, setMsgAlert] = React.useState("");

  React.useEffect(() => {
    if (idTipoUtente != Utenze.SOCIETA) {
      navigate("/");
    } else {
      setVisualizzaPagina(true);
    }
  }, []);

  // Handlers (invariati)
  const handleChangeDurata = (event) => {
    if (event.target.value === "Trimestrale") {
      setDurataAbbonamento("Trimestrale");
      setDatePickerAnno(false);
      setDatePickerMese(true);
      setDatePickerGiorno(false);
    }
  };

  const handleChange10 = (event) => setUtenti10(event.target.value);
  const handleChange15 = (event) => setUtenti15(event.target.value);

  function calcolaCosto() {
    const costo10 = utenti10 * 10;
    const costo15 = utenti15 * 15;
    return costo10 + costo15;
  }

  const buttonCLickPagamento = () => {
    buttonCLick();
  };

  const buttonCLick = () => {
    setIsClickableButton(false);
    let _dataInizioAbbonamento = "";
    let _dataFineAbbonamento = "";

    if (durataAbbonamento === "") {
      setMsgAlert("Errore: indicare il peridio di durata del corso");
      setAlertError(true);
      setAlertOk(false);
      setIsClickableButton(true);
    } else {
      setAlertError(false);

      if (durataAbbonamento === "Trimestrale") {
        let annoInizio = valueData.year().toString();
        let meseInizio = (valueData.month() + 1).toString();
        let meseFine = (valueData.month() + 3).toString();
        if (valueData.month() > 9) {
          meseFine = "12";
        }

        if (meseInizio < 10) {
          meseInizio = `0${meseInizio}`;
        }
        if (meseFine < 10) {
          meseFine = `0${meseFine}`;
        }

        _dataInizioAbbonamento = `${annoInizio}${meseInizio}01000001`;
        if (meseFine === "02") {
          _dataFineAbbonamento = `${annoInizio}${meseFine}28235959`;
        } else if (
          meseFine === "04" ||
          meseFine === "06" ||
          meseFine === "09" ||
          meseFine === "11"
        ) {
          _dataFineAbbonamento = `${annoInizio}${meseFine}30235959`;
        } else {
          _dataFineAbbonamento = `${annoInizio}${meseFine}31235959`;
        }
      }

      sendApiData(_dataInizioAbbonamento, _dataFineAbbonamento);
    }
  };

  const handleResult = (result) => {
    if (result?.error) {
      console.log(result.error.message);
    }
  };

  const sendApiData = (dataInizioAbbonamento, dataFineAbbonamento) => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const hh = String(now.getHours()).padStart(2, "0");
    const min = String(now.getMinutes()).padStart(2, "0");
    const sec = String(now.getSeconds()).padStart(2, "0");
    const today = `${yyyy}${mm}${dd}${hh}${min}${sec}`;

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append(
      "Access-Control-Allow-Headers",
      "Access-Control-Allow-Headers , X-Requested-With, Content-Type, Authorization"
    );
    myHeaders.append(
      "Access-Control-Allow-Methods",
      "PUT, GET, POST, DELETE, OPTIONS"
    );
    myHeaders.append("Cache-Control", "no-cache, no-store, must-revalidate");
    myHeaders.append("Pragma", "no-cache");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const body = JSON.stringify({
      createCheckoutSession: 1,
      dataInizio: dataInizioAbbonamento,
      dataFine: dataFineAbbonamento,
      durataAbbonamento: durataAbbonamento,
      numeroIscritto10Euro: utenti10,
      numeroIscritto15Euro: utenti15,
      insDate: today,
      updDate: today,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
    };

    fetch(constant.BASE_URL + "payment_init_gruppi_corsi.php", requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw navigate("/");
        } else {
          return response.json().then((data) => {
            stripePromise.then((stripe) => {
              stripe.redirectToCheckout({
                sessionId: data.sessionId,
              });
            });
          });
        }
      })
      .then(handleResult);
  };

  return (
    <div
      style={{
        backgroundColor: "#E5E5E5",
        height: "100vh",
      }}
    >
      {visualizzaPagina == true ? (
        <Grid>
          <InfoUserSocieta />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              //   height: "calc(100vh - 65px)",
            }}
          >
            <Paper elevation={10} className="paperStyle">
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  mb: 1,
                }}
              >
                <Tabs
                  value={currentTab}
                  onChange={(_, newValue) => navigate(newValue)}
                  //   variant="fullWidth"
                >
                  {TABS.map((t) => (
                    <Tab
                      key={t.value}
                      value={t.value}
                      //   icon={t.icon}
                      iconPosition="start"
                      label={t.label}
                      sx={{
                        // textTransform: "none",
                        fontSize: { xs: 12, sm: 14, md: 16 }, // cambia con il viewport
                        "&.Mui-selected": {
                          color: "primary.main",
                          fontWeight: 700,
                        },
                      }}
                    />
                  ))}
                </Tabs>
              </Box>

              <div style={{ padding: 20, minHeight: "75vh" }}>
                <h2 style={{ padding: "16px 0", textAlign: "center" }}>
                  Scegli il numero di Utenti
                </h2>
                <Grid container spacing={2} align="center">
                  <Grid item xs={12} md={6} className={"numero-persone-select"}>
                    <Box sx={{ m: 1, width: 300, mx: "auto" }}>
                      <h4 style={{ padding: "4px 0 12px 0", fontWeight: 400 }}>
                        Utenti con <b>2</b> ingressi settimanali (10€)
                      </h4>
                      <FormControl fullWidth>
                        <InputLabel id="select-utenti10">
                          Numero utenti
                        </InputLabel>
                        <Select
                          labelId="select-utenti10"
                          id="utenti10"
                          value={utenti10}
                          label="NumeroUtenti10"
                          onChange={handleChange10}
                          MenuProps={{
                            PaperProps: {
                              style: { maxHeight: 48 * 4.5 + 8, width: 250 },
                            },
                          }}
                        >
                          {Array.from({ length: 41 }, (_, i) => (
                            <MenuItem key={i} value={i}>
                              {i}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={6} className={"numero-persone-select"}>
                    <Box sx={{ m: 1, width: 300, mx: "auto" }}>
                      <h4 style={{ padding: "4px 0 12px 0", fontWeight: 400 }}>
                        Utenti con <b>3</b> ingressi settimanali (15€)
                      </h4>
                      <FormControl fullWidth>
                        <InputLabel id="select-utenti15">
                          Numero utenti
                        </InputLabel>
                        <Select
                          labelId="select-utenti15"
                          id="utenti15"
                          value={utenti15}
                          label="NumeroUtenti15"
                          onChange={handleChange15}
                          MenuProps={{
                            PaperProps: {
                              style: { maxHeight: 48 * 4.5 + 8, width: 250 },
                            },
                          }}
                        >
                          {Array.from({ length: 41 }, (_, i) => (
                            <MenuItem key={i} value={i}>
                              {i}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>
                </Grid>

                <h2 style={{ padding: "16px 0", textAlign: "center" }}>
                  Scegli la durata
                </h2>
                <Grid
                  align="center"
                  style={{
                    marginTop: 16,
                    flexDirection: "row",
                    flexWrap: "wrap",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      alignItems: "start",
                    }}
                  >
                    <FormControl
                      id="FormControl-tempo"
                      style={{ width: "80%" }}
                    >
                      <RadioGroup id="radioGroup-tempo">
                        <FormControlLabel
                          value={"Trimestrale"}
                          control={<Radio onChange={handleChangeDurata} />}
                          label="Trimestrale"
                          sx={{
                            m: 1,
                            width: "100%",
                            height: "56px",
                            //   p: 1,
                            border: "1px solid #5E2367",
                            borderRadius: 2,
                            backgroundColor:
                              durataAbbonamento === "Trimestrale"
                                ? "#5E236730"
                                : "transparent",
                            // color:
                            //   durataAbbonamento === "Trimestrale"
                            //     ? "white"
                            //     : "black",
                          }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>

                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      alignItems: "start",
                      marginTop: 8,
                    }}
                  >
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="it"
                    >
                      <Stack spacing={3} sx={{ width: "100%", maxWidth: 360 }}>
                        {DatePickerAnno && (
                          <DatePicker
                            views={["year"]}
                            label="Anno"
                            minDate={dayjs()}
                            value={valueData}
                            onChange={setValueData}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                helperText={null}
                                fullWidth
                              />
                            )}
                          />
                        )}
                        {DatePickerMese && (
                          <DatePicker
                            views={["year", "month"]}
                            label="Anno e mese di inizio"
                            minDate={dayjs()}
                            value={valueData}
                            onChange={setValueData}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                helperText={null}
                                fullWidth
                              />
                            )}
                          />
                        )}
                        {DatePickerGiorno && (
                          <DatePicker
                            views={["day"]}
                            label="Data"
                            minDate={dayjs()}
                            value={valueData}
                            onChange={setValueData}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                helperText={null}
                                fullWidth
                              />
                            )}
                          />
                        )}
                      </Stack>
                    </LocalizationProvider>
                  </div>
                </Grid>

                <Grid align="center" style={{ marginTop: 16 }}>
                  <h2 style={{ padding: "16px 0" }}>
                    Totale: {calcolaCosto()} €{" "}
                  </h2>

                  <Button
                    style={{
                      width: "auto",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                    disabled={isClickableButton ? false : true}
                    variant="contained"
                    margin="normal"
                    size="medium"
                    fullWidth
                    onClick={buttonCLickPagamento}
                  >
                    Scegli piano
                  </Button>
                </Grid>
              </div>

              {alertError ? (
                <Alert padding="20" severity="error">
                  {msgAlert}
                </Alert>
              ) : (
                <></>
              )}
              {alertOk ? <Alert severity="success">{msgAlert}</Alert> : <></>}
            </Paper>
          </div>
        </Grid>
      ) : (
        <></>
      )}
    </div>
  );
};

export default AbbonamentoSocietaCorso;
